import { useTranslation } from "react-i18next";
import { useSetRecoilState } from "recoil";
import { alertState } from "src/recoil/atoms/global";
import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useMutation } from "src/Hooks/useReactQuery";
import { createInstance } from "src/services/project-instances";
import APP_ROUTES from "src/routes/routes";

const useCreateInstance = () => {
  const { t } = useTranslation("project-instance");
  const navigate = usePatchedNavigate();
  const showAlert = useSetRecoilState(alertState);

  const createInstanceMutation = useMutation({
    mutationFn: ({ data }) => createInstance({ data }),
  });

  const submitData = ({ data }, callback) => {
    createInstanceMutation.mutate(
      { data },
      {
        onSuccess: () => {
          showAlert({
            status: true,
            message: t("new.create_success"),
            type: "success",
          });
          navigate(APP_ROUTES.PROJECT_INSTANCE);
        },
        onError: () => {
          const isSubmitFailed = true;
          callback?.(isSubmitFailed);
        },
        onSettled: () => {
          const isSubmitFailed = false;
          callback?.(isSubmitFailed);
        },
      }
    );
  };

  return {
    createInstanceMutation,
    submitData,
    isLoading: createInstanceMutation.isLoading,
    isError: createInstanceMutation.isError,
    error: createInstanceMutation.error,
  };
};

export default useCreateInstance;
